import { Attribute, ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'cs-table-cell',
  templateUrl: 'cs-table-cell.html',
  host: { 'class': 'table-cell' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTableCell {
  constructor(
    @Attribute('align') public align?: 'left' | 'center' | 'right'
  ) {}

  @HostBinding('class.align-center') get isCenter() {
    return this.align === 'center';
  }

  @HostBinding('class.align-right') get isRight() {
    return this.align === 'right';
  }
}
